
exports.onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    // eslint-disable-next-line global-require
    require(`intersection-observer`);
  }
};
